export default __webpack_public_path__ + "js/components/liveClassPurchasePage/component/BenefitScreen/cross-f74a9d5370f2d4a21b5063e997893eea.svg";